import {Component, Injector, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {AbstractControl, UntypedFormGroup} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastService} from '../../../../../main/services';
import {
    DeliveryPointStruct, IataServiceLevelStruct, RefuelerCompanyCodeStruct
} from '../../../../../common/models';
import {Contract} from '../../../../models';
import {createProductServiceForm} from '../../../../forms';
import {ProductService, ProductServiceStruct} from '../../../../models/product-service/product-service';
import {DeliveryPointService} from '../../../../../common/services/delivery-point/delivery-point.service';
import {IataServiceLevelService, RefuelerCompanyCodeService} from '../../../../../common/services';
import {ContractProductServiceService} from '../../../../services';
import {ActivatedRoute, Router} from '@angular/router';
import {FormValidationErrorsHelper} from "../../../../../common/helpers/forms/form-validation-errors-helper";

@Component({
    selector: 'jft-edit-product-service-modal',
    templateUrl: './edit-product-service-modal.component.html',
    styleUrls: ['./edit-product-service-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditProductServiceModalComponent implements OnInit {

    public form: UntypedFormGroup;
    public deliveryPoints: DeliveryPointStruct[];
    public iataServiceLevels: IataServiceLevelStruct[];
    public refuelerCompanyCodes: RefuelerCompanyCodeStruct[];
    public tenderId: string;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        public contract: Contract,
        public productService: ProductService,
        private toast: ToastService,
        private service: ContractProductServiceService,
        private deliveryPointService: DeliveryPointService,
        private iataServiceLevelService: IataServiceLevelService,
        private refuelerCompanyCodeService: RefuelerCompanyCodeService,
        private activeModal: NgbActiveModal,
    ) {
    }

    public ngOnInit() {
        this.tenderId = this.route.parent.snapshot.params.id;
        this.getDeliveryPoints();
        this.getIataServiceLevelService();
        this.getRefuelerCompanyCode();

        this.form = createProductServiceForm(this.productService);
    }

    private getDeliveryPoints() {
        this.deliveryPointService.fetch().subscribe((item: DeliveryPointStruct[]) => {
            this.deliveryPoints = item;
        }, e => {
            console.error(e);
        });
    }

    private getIataServiceLevelService() {
        this.iataServiceLevelService.fetch().subscribe((item: IataServiceLevelStruct[]) => {
            this.iataServiceLevels = item;
        }, e => {
            console.error(e);
        });
    }

    private getRefuelerCompanyCode() {
        this.refuelerCompanyCodeService.fetch().subscribe((item: RefuelerCompanyCodeStruct[]) => {
            this.refuelerCompanyCodes = item;
        }, e => {
            console.error(e);
        });
    }

    public close() {
        this.activeModal.dismiss();
    }

    public submit() {
        if (this.form.controls.id && this.form.controls.id.value) {
            this.service.update(this.tenderId, this.contract.id, this.form.controls.id.value, this.form.value).subscribe(() => {
                this.toast.success('Product has been successfully updated');
                this.close();
            }, (e) => {
                this.toast.error(e);
            });
        } else {
            this.service.create(this.tenderId, this.contract.id, this.form.value).subscribe(() => {
                this.toast.success('Product has been successfully created');
                this.close();
            }, (e) => {
                this.toast.error(e);
            });
        }
    }
    public getFirstFormGroupErrorLabel(form: UntypedFormGroup) {
        if (form.valid) {
            return ''
        }

        let formValidationErrors = new FormValidationErrorsHelper();
        let formErrorLabel = formValidationErrors.getFirstErrorFormLabel(form);

        if (formErrorLabel) {
            return formErrorLabel;
        }
        return '';
    }

    public getFormGroupErrorClasses(control: AbstractControl, isInvalid: boolean = false): {} {
        if (isInvalid) {
            return {'is-invalid': control.invalid};
        }
        return {'is-invalid': control.invalid && control.touched};
    }

    public showErrorBlock(control: AbstractControl): boolean {
        return control.errors && (control.dirty || control.touched);
    }
}
